// extracted by mini-css-extract-plugin
export default {"wrapper":"expandable_badge_list-module___wrapper___e84f47f8"};